import { i18n } from "@dehub/theme";
import { handleError } from "../../utils/error-handler";

/**
 * The amendment endpoints refuse with a bare code in `message`
 * (`AMEND_BELOW_PAID`, `PENDING_EXISTS`, `error.invoice.amend_refused` …).
 * Translate the ones we know; anything else falls through to handleError.
 */
const KNOWN: Record<string, string> = {
  "error.invoice.amend_refused": "invoice:amend.errors.refused",
  "error.invoice.amendment_not_pending": "invoice:amend.errors.notPending",
  "error.invoice.amendment_not_found": "invoice:amend.errors.notFound",
};

/** Resolve amendment API error to a translated string (no toast). */
export function getAmendErrorMessage(error: unknown): string | null {
  const err = error as { message?: string | { message?: string } };
  const raw = typeof err?.message === "string" ? err.message : err?.message?.message;
  const code = raw?.trim();
  if (!code) return null;
  const key = KNOWN[code] ?? `invoice:amend.reasons.${code}`;
  const text = i18n.t(key, { defaultValue: "" });
  return text || code;
}

export function handleAmendError(error: unknown) {
  const text = getAmendErrorMessage(error);
  if (text) {
    handleError({ message: text });
    return;
  }
  handleError(error);
}
